export { default as ProgressBarText } from './progressBarText'



// WEBPACK FOOTER //
// ./src/modules/persistent-cart/progressBarText/index.js